import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import content from './content'
import source from './source'
import { storageKey } from '../helpers/localStorage'

Vue.use(Vuex)
const getDefaultState = () => {
    return {
        user: {},
        pendingTransactionWebinar: '',
        pendingTransactionCourse: '',
        sidebarExtended: false,
        boughtItems: [],
        sidebarForm: '',
        region: 'pl',
        roleStorage: {},
        loading: false,
        warning: {},
        currentPromoCodes: {}
    }
}
const vuexPersist = new VuexPersist({
    key: storageKey(),
    storage: window.localStorage
})
const store = new Vuex.Store({
    state: getDefaultState(),
    plugins: [vuexPersist.plugin],
    mutations: {
        setPromoCode(state, payload) {
            state.currentPromoCodes[payload.uuid] = payload.code
        },
        setWarning(state, warning) {
            state.warning = warning
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        hideWarning(state) {
            state.warning = {}
        },
        setPendingTransactionWebinar(state, webinar) {
            state.pendingTransactionWebinar = webinar
        },
        setPendingTransactionCourse(state, webinar) {
            state.pendingTransactionCourse = webinar
        },
        setRoleStorage(state, roleStorage) {
            state.roleStorage = roleStorage
        },
        setUser(state, user) {
            state.user = user
        },
        setBoughtItems(state, items) {
            state.boughtItems = items
        },
        toggleSidebar(state) {
            state.sidebarExtended = !state.sidebarExtended
            state.sidebarForm = ''
        },
        setSidebarForm(state, form) {
            state.sidebarExtended = true
            state.sidebarForm = form
        },
        resetState(state) {
            state.user = {}
            state.sidebarExtended = false
            state.boughtItems = []
            state.sidebarForm = ''
            state.currentPromoCodes = {}
        }
    },
    actions: {
        resetStore({ commit }) {
            commit('resetState')
        },
        toggleSidebar({ commit }) {
            commit('toggleSidebar')
        }
    },
    modules: {
        content,
        source
    }
})
export default store
